import { LuLayers } from "react-icons/lu";
import { cn } from "@/lib/utils";

type SuperSingleBadgeProps = {
  className?: string;
};

/** Marks a one-track release that ships extra versions (LUT-901). */
export default function SuperSingleBadge({ className }: SuperSingleBadgeProps) {
  return (
    <div
      className={cn(
        "inline-flex h-7 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-pink-3/80 bg-[#3B1A2C] px-3 font-open-sans text-xs font-semibold uppercase tracking-wide text-white",
        className,
      )}
      data-testid="super-single-badge"
    >
      <LuLayers className="h-4 w-4 text-pink-3" />
      Super Single
    </div>
  );
}
